import { TOOLS_SERVICE } from "@/services/tools.service.js";
import router from '@/router/index';

const state = { listOutput: {}, toolOutput: {}, updateStatusTool: false};

const actions = {
    getList({ dispatch, commit }, inputGetTools) {
        dispatch('alert/clear', null, { root: true });
        commit('listRequest');
        
        TOOLS_SERVICE.list(inputGetTools.pageNumber, inputGetTools.resultsNumber, inputGetTools.searchText, inputGetTools.status, inputGetTools.orderBy)
            .then(
                output => {
                    commit('listSuccess', output);
                },
                error => {
                    commit('listFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    editTool({ dispatch, commit }, inputTool) {
        dispatch('alert/clear', null, { root: true });
        commit('editRequest');

        // Filter out existing attributes since this can not be edited
        inputTool.tool.attributes = inputTool.tool.attributes.filter(attribute => !Boolean(attribute.id));

        TOOLS_SERVICE.edit(inputTool.id, inputTool.tool, inputTool.photo)
            .then(
                output => {
                    commit('editSuccess', output);
                },
                error => {
                    commit('editFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    addTool({ dispatch, commit }, inputTool) {
        dispatch('alert/clear', null, { root: true });
        commit('addRequest');

        TOOLS_SERVICE.add(inputTool.tool, inputTool.photo)
            .then(
                output => {
                    commit('addSuccess', output);
                },
                error => {
                    commit('addFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    getTool({ dispatch, commit }, toolId) {
        dispatch('alert/clear', null, { root: true });
        commit('getRequest');

        TOOLS_SERVICE.get(toolId)
            .then(
                output => {
                    commit('getSuccess', output);
                },
                error => {
                    commit('getFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    updateStatus({ dispatch, commit }, inputStatus) {
        dispatch('alert/clear', null, { root: true });
        commit('updateStatusRequest');

        TOOLS_SERVICE.updateStatus(inputStatus.id, inputStatus.status)
            .then(
                output => {
                    commit('updateStatusSuccess', output);
                },
                error => {
                    commit('updateStatusFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    /* List */
    listRequest(state) {
        //
    },
    listSuccess(state, output) {
        state.listOutput = output;
    },
    listFailure(state) {
        state.listOutput = {};
    },
    /* Add */
    addRequest(state) {
    },
    addSuccess(state) {
        router.push('/ferramentas/lista');
    },
    addFailure(state) {
        //
    },
    /* Edit */
    editRequest(state) {
    },
    editSuccess(state) {
        router.push('/ferramentas/lista');
    },
    editFailure(state) {
        //
    },
    /* Get */
    getRequest(state) {
        //
    },
    getSuccess(state, output) {
        state.toolOutput = output;
    },
    getFailure(state) {
        state.toolOutput = {};
    },
    /* Update status */
    updateStatusRequest(state) {
        state.updateStatusTool = undefined;
    },
    updateStatusSuccess(state) {
        state.updateStatusTool = true;
    },
    updateStatusFailure(state) {
        state.updateStatusTool = false;
    },
};

export const tools = {
    namespaced: true,
    state,
    actions,
    mutations
};